module.exports = __webpack_public_path__ + "media/images/procedimiento-consulta-2904cdd8169833b12bbe8380f1e40367.png";